import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import { Children, Fragment, type JSX } from "react";

import type { PageHeaderMetaProps } from "./PageHeader.types";

export function PageHeaderMeta({
  children,
  className,
}: PageHeaderMetaProps): JSX.Element {
  const parts = Children.toArray(children).filter(Boolean);

  return (
    <div data-slot="page-header-meta" className={clsx(styles.meta, className)}>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {index > 0 && (
            <span aria-hidden="true" className={styles.dot}>
              ·
            </span>
          )}
          {part}
        </Fragment>
      ))}
    </div>
  );
}
